/* ==========================================================================
   ModalSearcher > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    init: true,
    component: 'ModalSearcher',
    type: {
        modal: 'modal-searcher'
    },
    selector: {
        modal: '[data-component="Modal"][data-type="modal-searcher"]',
        image: '[data-component="Modal"][data-type="modal-searcher"] [data-component="ImageRxjs"]'
    },
    css: {
        component: 'modal',
        modal: 'modal--searcher',
        modalBody: 'modal--searcher-body',
        modalPrice: 'price--lg',
        headerTitle: 'modal-header__title',
        productSearcher: 'product-searcher'
    },
    image: {
        resize: {
            width: 700,
            height: 500
        }
    }
};

module.exports = () => config;
